module.exports = __webpack_public_path__ + "ionicons.621bd386841f74e0053c.svg";


//////////////////
// WEBPACK FOOTER
// E:/Release/InzuzoA/InzuzoA/fonts/ionicons.svg?v=2.0.0
// module id = ../../../../../fonts/ionicons.svg?v=2.0.0
// module chunks = styles